import { Injectable } from '@angular/core';
import { LanguageEnum } from '../shared/common/enums';
import { languageKey } from '../shared/common/constants';
import { HttpClient } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';
import { PrimeNGConfig } from 'primeng/api';
import { LanguageShortKeyPrefix, LanguageDisplayNameToKeyMapping } from '../shared/common/constants';
import { firstValueFrom } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class LocalizationService {
    formatDate: any;
    langCode: string;
    langName: string;
    langId: string;
    translatedTextList: any;
    translatePath = "Key";
    langList = ['en-US', 'tr-TR'];
    customTranslatedTextList: any;

    constructor(private translateService: TranslateService, private primeConfig: PrimeNGConfig) {
        this.getLangCode();
    }

    getLangCode(){
      if (JSON.parse(localStorage.getItem(languageKey)) != null) {
        this.langCode = JSON.parse(localStorage.getItem(languageKey)).code;
        this.langId = JSON.parse(localStorage.getItem(languageKey)).id;
        this.langName = "EN"
      }else{
        this.langCode = "tr-TR";
        this.langId = LanguageEnum.TurkishTurkey;
        this.langName = "TR"
      }
    }

    public initTranslate(http: HttpClient): Promise<void> {
      this.getLangCode();
      this.langId = this.langCode === 'tr-TR' ? LanguageEnum.TurkishTurkey : LanguageEnum.EnglishUnitedStates;
      this.translateService.addLangs(this.langList);
      this.translateService.setDefaultLang(this.langCode);
      this.translateService.get('primeng').subscribe(res => this.primeConfig.setTranslation(res));
      this.translateService.get(this.translatePath).subscribe(x => {
        this.translatedTextList = x;
      });
        return;
    }

    translateText(textPath: string){
      let text = '';
      this.translateService.get( this.translatePath +'.'+ textPath ).subscribe(x =>{
        text = x;
      })
      return text;
    }

    translateTextWithoutKey(textPath: string){
      let text = '';
      this.translateService.get( textPath ).subscribe(x =>{
        text = x;
      })
      return text;
    }

    getLangShortText (langId: string, questionCollectionLanguageList: any[]): string {
      if (!langId || !questionCollectionLanguageList || !this.translatedTextList) return '';

      const keyName = questionCollectionLanguageList.find(x => x.id === langId)?.name;
      const mappedKeyName = LanguageDisplayNameToKeyMapping[keyName] || keyName;
      const text = mappedKeyName ?? false ? this.translatedTextList[LanguageShortKeyPrefix + mappedKeyName] : '';
      
      return text;
    }

    async loadWantedTranslation(langID: string):Promise<void>{
      const languageCode = langID === LanguageEnum.TurkishTurkey ? 'tr-TR' : 'en-US';
      const dict = await firstValueFrom(this.translateService.getTranslation(languageCode));
      this.customTranslatedTextList = dict ?? {};
    }

    translateTextWithCustomList(key: string){
      if (!this.customTranslatedTextList) return '';
      return this.translateService.parser.getValue(this.customTranslatedTextList, key) ?? '';
    }
    
}
